import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';

@Component({
    selector: 'app-fullscreen-head',
    templateUrl: './fullscreen-head.component.html',
    styleUrls: ['./fullscreen-head.component.scss'],
    standalone: false
})
export class FullscreenHeadComponent {

  @Input() headerTitle: string;
  @Input() iconType: string;
  @Input() selector: string;
  @Input() rightHeaderContent: TemplateRef<any>;
  @Input() buttonHeaderContent: TemplateRef<any>;
  @Output() clickEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
  ) {}
}